import { SearchResults, SelectedFilter } from "../Shared/scriptts/interfaces";
import { getUserObject, setUserObject } from "../Shared/scriptts/session/sessionmain";
import { displayRemoteFilters } from './Templates/search-filter-remote';
import { displayOrganizationFilter, resetOrganizationFilter } from './Templates/search-filter-organization';
import { displayPayFilter } from './Templates/search-filter-pay';
import { displaySeriesFilter, resetSeriesFilter } from './Templates/search-filter-series';
import { displayNoPartialFilters } from './Templates/search-filter-nopartial';
import { defaultRadius, minimumRadius, displayLocationFilter } from './Templates/search-filter-location';
import { displaySearchedLocationFilter } from './Templates/search-filter-searched_location';
import { displayWorkSiteFilter } from "./Templates/search-filter-work_site";
import { displayFilterPills } from './Templates/search-filter-pills';
import { brandedSearch, params, aliasMapping, executeSearchUrl, displayResults, setParams, signinClick, hasKeywordOrFilter } from './search-main';
import { DefaultExistingParams, MergeParams } from "../Shared/scriptts/search-params";
import { displayDefaultFilters } from './Templates/search-filter-default';
import { displayRelocationFilter } from "./Templates/search-filter-relocation";
export let userFilters: SelectedFilter[] = [];
export let filterCount = 0;
export let preferenceToggle: boolean = false;

declare var gIsSearchFiltersEnabled: boolean;

document.addEventListener('DOMContentLoaded', () => {   
    document.querySelector<HTMLButtonElement>('#filter-toggle-all')?.addEventListener('click', searchFiltersToggleAllClick);
    document.querySelector<HTMLButtonElement>('#clear-all-filters')?.addEventListener('click', clearAllSearchFiltersClick);
});

export function initBrandedSearch() {
    if (!brandedSearch) {
        return;
    }
    const removeFiltersTextElem = document.querySelector<HTMLElement>('#remove-filters-text');

    setParams(MergeParams(DefaultExistingParams(structuredClone(brandedSearch)), params));

    if (!removeFiltersTextElem) {
        return;
    }
    removeFiltersTextElem.innerText = 'Remove filters you added';
}

export function displayFilters(data: SearchResults) {
    displayRemoteFilters(data);
    displayOrganizationFilter(data);
    displayPayFilter();
    displaySeriesFilter(data);
    displayNoPartialFilters(data);
    if (gIsSearchFiltersEnabled) {
        displaySearchedLocationFilter();
    }
    displayLocationFilter(data);
    if (gIsSearchFiltersEnabled) {
        displayWorkSiteFilter(data);
        displayRelocationFilter(data);
    }
    displayFilterPills();
    const filterCountElem = document.querySelector<HTMLElement>('#filter-count');
    const clearAllFiltersButton = document.querySelector<HTMLButtonElement>('#clear-all-filters');

    if (hasKeywordOrFilter(true)) {
        clearAllFiltersButton?.classList.remove('hidden');
    }
    else {
        clearAllFiltersButton?.classList.add('hidden');
    }
   
    if (!filterCountElem) {
        return;
    }
    if (filterCount > 0) {
        filterCountElem.innerText = filterCount.toString();
        filterCountElem.classList.remove('hidden');
    }
    else {
        filterCountElem.innerText = '0';
        filterCountElem.classList.add('hidden');
    }   
}

/**
 * Add a value to an array parameter in the params array
 * @param propertyName The name of the array property to add the value to
 * @param value The value to push to the parameter array
 */
export function addToArrayParam(propertyName: any, value: string) {
    if (!params.hasOwnProperty(propertyName)) {
        params[propertyName] = [];
    }
    if (!Array.isArray(params[propertyName])) {
        return;
    }
    if (params[propertyName]?.indexOf(value) === -1) {
        params[propertyName].push(value);
        params.Page = '1';

        if (propertyName === 'LocationName') {
            params.Radius = (!params.Radius) ? defaultRadius : params.Radius;
        }
    }
}

/**
 * Removes a from an array parameter value in the params array
 * @param propertyName The name of the array property remove the value from
 * @param value The value to remove from the parameter array
 */
export function removeFromArrayParam(propertyName: any, value: string) {
    if (!params.hasOwnProperty(propertyName) || !Array.isArray(params[propertyName])) {
        return;
    }
    const tempParams = params;
    const index = tempParams[propertyName]?.indexOf(value);

    if (index > -1) {
        tempParams[propertyName].splice(index, 1);
        tempParams.Page = '1';
    }
    setParams(tempParams);
}

export function removeParam(propertyName: any, value: string) {
    const tempParams = params;
    const param = params[propertyName];
    if (Array.isArray(param)) {
        removeFromArrayParam(propertyName, value);
    }
    else if (propertyName === 'Radius') {
        tempParams.Radius = minimumRadius;
    }
    else {
        tempParams[propertyName] = null;
    }

    if (propertyName === 'LocationName') {
        tempParams.Radius = undefined;
    }

    if (propertyName === 'GradeBucket' || propertyName === 'RemunerationMinimumAmount') {
        tempParams.GradeBucket = [];
        tempParams.RemunerationMinimumAmount = null;
        tempParams.RemunerationMaximumAmount = null;
        tempParams.GradeSearch = undefined;
    }

    tempParams.Page = '1';
    setParams(tempParams);
}

export function addParam(propertyName: any, value: string) {
    const param = params[propertyName];
    if (Array.isArray(param)) {
        addToArrayParam(propertyName, value);
        return;
    }

    params[propertyName] = value;
}

export function isBrandedSearchFilter(param: string, value: string) {
    const property = aliasMapping[param].JOAQueryName;
    if (!brandedSearch.hasOwnProperty(property)) {
        return false;
    }

    const filterValue = brandedSearch[property];

    if (Array.isArray(filterValue)) {
        return filterValue.indexOf(value) > -1;
    }
    else {
        return filterValue.toString().toLowerCase() == value.toLowerCase();
    }
}

export function resetFilterCount() {
    filterCount = 0;
}

export function setFilterCount(value: number) {
    filterCount = value;
}

export function getPreferenceToggle(): boolean {
    return preferenceToggle;
}

export function getNormalizedFilterName(name: string, id: string) {
    let pillName = name;
    if (pillName.indexOf('miles') > -1) {
        return pillName;
    }
    pillName = pillName.substring(0, pillName.indexOf('(')).trim();

    switch (id) {
        case "hiring_path-graduates":
            return pillName += " (Hiring path)";
        case "work_type-15326":
            return pillName += " (Appointment type)";
        case "work_type-15522":
            return pillName += " (Appointment type)";
        case "work_schedule-4":
            return pillName += " (Work schedule)";
        case "work_schedule-6":
            return pillName += " (Work schedule)";
        case "work_type-15327":
            return pillName += " (Appointment type)";
        case "security_clearance-0":
            return pillName += " (Security clearance)";
        case "travel_percentage-0":
            return pillName += " (Travel percentage)";
        default:
            return pillName;
    }
}

function searchFiltersToggleAllClick(evt: Event) {
    const toggleButton = <HTMLButtonElement>(evt.target);
    let expand = toggleButton.getAttribute('data-expanded') === 'false';
    toggleButton.innerText = expand ? 'Collapse all' : 'Expand all';
    toggleButton.setAttribute('data-expanded', expand.toString());
    document.querySelectorAll<HTMLButtonElement>('[data-target^="search-filters_"]').forEach(elem => {
        if (elem.getAttribute('aria-expanded') === (!expand).toString()) {
            elem.dispatchEvent(new Event('click'));
        }
    });
}

function getSearchFilterPropertyNames(): string[] {
    const filterPropertyNames: string[] = [];

    for (const key of Object.keys(aliasMapping)) {
        if (!aliasMapping[key]?.SearchFilter) {
            continue;
        }

        const propertyName = aliasMapping[key]?.JOAQueryName?.toString();
        if (!propertyName || filterPropertyNames.includes(propertyName) || propertyName === 'Keyword') {
            continue;
        }

        filterPropertyNames.push(propertyName);
    }
    return filterPropertyNames;
}

function resetFilterProperty(nextParams: any, propertyName: string) {
    if (brandedSearch?.hasOwnProperty(propertyName)) {
        nextParams[propertyName] = structuredClone(brandedSearch[propertyName]);
        return;
    }
    nextParams[propertyName] = Array.isArray(nextParams[propertyName]) ? [] : undefined;
}

export function clearAllSearchFilters() {
    const nextParams = DefaultExistingParams(structuredClone(params));
    const filterPropertyNames = getSearchFilterPropertyNames();
    resetOrganizationFilter();
    resetSeriesFilter();
    filterPropertyNames.forEach(propertyName => {
        resetFilterProperty(nextParams, propertyName);
    });
    if (!brandedSearch?.hasOwnProperty('GradeBucket')) {
        nextParams.GradeBucket = [];
    }
    if (!brandedSearch?.hasOwnProperty('GradeBucket')
        && !brandedSearch?.hasOwnProperty('RemunerationMinimumAmount')
        && !brandedSearch?.hasOwnProperty('RemunerationMaximumAmount')) {
        nextParams.GradeSearch = undefined;
    }

    if (!brandedSearch?.hasOwnProperty('Radius')) {
        nextParams.Radius = undefined;
    }

    nextParams.Page = '1';

    setParams(nextParams);

    if (gIsSearchFiltersEnabled && !brandedSearch) {
        let userObject = getUserObject();
        userObject.UseDefaultFilters = false;
        setUserObject(userObject);
        displayDefaultFilters();
    }
}

export function clearAllSearchFiltersClick() {
    clearAllSearchFilters();
    displayResults(executeSearchUrl, false, true);
} 
